<template>
	<div class="bg-brand-taupe-500">
	    <PageHeader :headingContent="headingContent" />
		<div class="px-4 pb-20">
			<div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
				<div class="flex flex-wrap items-center w-full">
					<div class="w-full md:w-1/2 relative">
						<input v-model="searchTermValue" class="w-full p-2 mb-4 bg-white-100 border-2" maxlength="50" placeholder="Search email addresses" autocomplete="off"/>
						<div class="absolute right-2 top-3 cursor-pointer" @click="search">
							<i class="fa-solid fa-magnifying-glass"></i>
						</div>
					</div>
					<div class="flex items-center md:justify-end mb-4 w-full md:w-1/2">
						<div class="mr-2">Status Toggle</div>
						<div class="border-t-2 border-l-2 border-b-2 px-4 py-2 rounded-l-full cursor-pointer" :class="additionalToggleClasses('all')"
							@click="updateToggle('all')">
							All
						</div>
						<div class="border-t-2 border-l-2 border-b-2 px-2 py-2 cursor-pointer" :class="additionalToggleClasses('submitted')"
							@click="updateToggle('submitted')">
							Submitted
						</div>
						<div class="border-2 px-2 py-2 rounded-r-full cursor-pointer" :class="additionalToggleClasses('inProgress')"
							@click="updateToggle('inProgress')">
							In Progress
						</div>
					</div>
				</div>
				<div class="w-full">
					<template v-if="reviews.length === 0">
						<div class="w-full p-4 border-2 border-yellow-200 bg-yellow-100 flex items-center justify-center">
							No data returned based on the filter selection.
						</div>
					</template>
					<template v-else>
						<table class="border-2 table-auto lg:table-fixed w-full">
							<thead>
								<tr class="bg-gray-100 cursor-default">
									<th class="p-4">Email</th>
									<th class="p-4">Title</th>
									<th class="p-4">Status</th>
									<th class="p-4">Date</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(review, index) in reviews" :key="index" class="even:bg-gray-50 hover:bg-yellow-50 cursor-default"
									@click="visitReview(review.id)">
									<td class="px-2 py-3">
										<template v-if="review.user">{{ review.user.email }}</template>
										<template v-else>N/A</template>
									</td>
									<td class="px-2 py-3">{{ review.title }}</td>
									<td class="px-2 py-3 capitalize">{{ review.status.replace('_', ' ') }}</td>
									<td class="px-2 py-3">
										<template v-if="review.status === 'submitted'">
											{{ $moment(review.submitted_at).format("DD MMM YYYY HH:mm") }}
										</template>
										<template v-else>
											{{ $moment(review.updated_at).format("DD MMM YYYY HH:mm") }}
										</template>
									</td>
								</tr>
							</tbody>
						</table>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import Layout from "@/Shared/Layouts/Admin/Layout";
import { Inertia } from "@inertiajs/inertia";

export default {
	components: {
		PageHeader,
	},
	computed: {
		filterQueryParameters() {
			let result = "?filter[email]=";
			if(this.searchTermValue) {
				result += this.searchTermValue;
			}
			
			return result + "&filter[status]=" + this.toggle;
		},
	},
	data() {
		return {
			headingContent: {
				hero: {
					image: "/images/263918963_cars_hero.jpg",
					title: "Fleet Risk Review",
					subtitle: "In association with AXA Insurance",
				},
				page: {
					title: "Reviews",
					subtitle: "",
				},
			},
			searchTermValue: this.searchTerm,
			timeout: null,
			toggle: this.statusToggle,
		};
	},
	layout: Layout,
	methods: {
		additionalToggleClasses(toggleValue) {
			if(
				(this.toggle === toggleValue) ||
				(toggleValue === 'all' && this.toggle === '')
			) {
				return "bg-brand-blue-400 text-white cursor-default";
			}

			return "";
		},
		fetchFilteredData() {
			Inertia.visit("/admin/reviews" + this.filterQueryParameters, {
				only: ['reviews', 'searchTerm', 'statusToggle'],
				preserveScroll: true,
				preserveState: true,
			});
		},
		search() {
			this.fetchFilteredData();
		},
		updateToggle(newToggleValue) {
			this.toggle = newToggleValue;
			this.fetchFilteredData();
		},
		visitReview(id) {
			Inertia.visit("/admin/reviews/" + id);
		}
	},
	props: ["searchTerm", "statusToggle", "reviews"],
	watch: {
		searchTermValue(newValue, oldValue) {
			if(newValue !== oldValue) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.timeout = null;
					this.search();
				}, 500);
			}
		}
	}
};
</script>